// extracted by mini-css-extract-plugin
export default {"zoomControls":"Y--z","zoomControlButton":"Z--z","zoomBanner":"_--z","bannerButton":"a_-z","imageButton":"b_-z","zoom":"c_-z","zoomContent":"d_-z"};